module.exports = __webpack_public_path__ + "share-of-in-store.svg?22f8dd9887324ed6dfd200d1c6116c4d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share-of-in-store.svg
// module id = 322
// module chunks = 2